/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthUserData } from '../models/AuthUserData';
import type { RegisterUserData } from '../models/RegisterUserData';
import type { RegisterUserStatus } from '../models/RegisterUserStatus';
import type { RestoreUserPasswordData } from '../models/RestoreUserPasswordData';
import type { SendUserPasswordData } from '../models/SendUserPasswordData';
import type { User } from '../models/User';
import type { UserAuthorizedStatus } from '../models/UserAuthorizedStatus';
import type { UserLoggedOutStatus } from '../models/UserLoggedOutStatus';
import type { UserPasswordRestoredData } from '../models/UserPasswordRestoredData';
import type { UserPasswordSentStatus } from '../models/UserPasswordSentStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * RegisterUser
     * @returns RegisterUserStatus UserRegistered
     * @throws ApiError
     */
    public static registerUser({
        requestBody,
    }: {
        requestBody: RegisterUserData,
    }): CancelablePromise<RegisterUserStatus> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error response`,
                500: `Error response`,
            },
        });
    }
    /**
     * GetUser
     * @returns User UserGot
     * @throws ApiError
     */
    public static getUser({
        id,
    }: {
        /**
         * User ID
         */
        id: number,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Error response`,
                500: `Error response`,
            },
        });
    }
    /**
     * GetUserSelf
     * @returns User UserSelfGot
     * @throws ApiError
     */
    public static getUserSelf(): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/self',
            errors: {
                400: `Error response`,
                500: `Error response`,
            },
        });
    }
    /**
     * AuthUser
     * @returns UserAuthorizedStatus UserAuthorized
     * @throws ApiError
     */
    public static authUser({
        requestBody,
    }: {
        requestBody: AuthUserData,
    }): CancelablePromise<UserAuthorizedStatus> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/auth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error response`,
                500: `Error response`,
            },
        });
    }
    /**
     * LogoutUser
     * @returns UserLoggedOutStatus UserLoggedOut
     * @throws ApiError
     */
    public static logoutUser(): CancelablePromise<UserLoggedOutStatus> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/logout',
            errors: {
                400: `Error response`,
                500: `Error response`,
            },
        });
    }
    /**
     * SendUserPassword
     * @returns UserPasswordSentStatus UserPasswordSent
     * @throws ApiError
     */
    public static sendUserPassword({
        requestBody,
    }: {
        requestBody: SendUserPasswordData,
    }): CancelablePromise<UserPasswordSentStatus> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/password/send',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error response`,
                500: `Error response`,
            },
        });
    }
    /**
     * RestoreUserPassword
     * @returns UserPasswordRestoredData UserPasswordRestored
     * @throws ApiError
     */
    public static restoreUserPassword({
        requestBody,
    }: {
        requestBody: RestoreUserPasswordData,
    }): CancelablePromise<UserPasswordRestoredData> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/password/restore',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error response`,
                500: `Error response`,
            },
        });
    }
}
